import general from "../../general";
import {useEffect, useState} from "react";
import {prod} from "../../env";
import Dialog from "../../lib/Dialog";
import useActiveState from "../../lib/useActiveState";
import {useLocalStorageState, useLockFn} from "ahooks";

const tasks = [
  {
    name: '每日登陆游戏',
    reward: '＋2金币',
    id: 'loginGame',
    info: '每日登录游戏就可领',
    operate: '去完成',
    operalias: 'go-complate',
  },
  {
    name: '每日首充',
    reward: '＋8金币',
    id: 'recharge',
    info: '每日只要首充，即可获得奖励',
    operate: '去完成',
    operalias: 'go-complate',
  },
  {
    name: '累计签到',
    reward: '＋100金币',
    id: 'CumulativeSignIn',
    info: '累计签到58次即可获得100金币奖励',
    operate: '去完成',
    operalias: 'go-complate',
  },
  {
    name: '优质评价',
    reward: '＋30金币',
    id: 'goodCommentNew',
    info: '优质评价让你金币拿到手软',
    operate: '去完成',
    operalias: 'go-complate',
  },
  {
    name: '充值满100元',
    reward: '＋50金币',
    id: 'Recharge100',
    info: '累计充值100元，即可获得奖励',
    operate: '去完成',
    operalias: 'go-complate',
  },
  {
    name: '充值满1000元',
    reward: '＋666金币',
    id: 'Recharge1000',
    info: '累计充值1000元，即可获得奖励',
    operate: '去完成',
    operalias: 'go-complate',
  },
];
// const router = [];

export default props => {
  const [loading, setLoading] = useState(false);
  const [loaded, setLoaded] = useState(false);
  const [data, setData] = useState([]);
  const [config] = useActiveState('config');
  // const [isDY, setIsDy] = useState(false);
  // const [newTaskList, setNewTaskList] = useLocalStorageState('task-navlists', tasks);
  // const [TaskList, setTaskList] = useLocalStorageState('task-lists', []);

  let [agent] = useActiveState('agent');
  let [app] = useActiveState('app');

  const load = () => {
    if (loading) {
      return;
    }
    setLoading(true);
    Dialog.loading();
    general.axios.post('/user/Task2207/getWelfareData')
        .finally(() => {
          setLoading(false);
          Dialog.close();
        })
        .then(response => {
          setLoaded(true);
          let result = response.data;
          if (!result.status.succeed) {
            Dialog.error(result.status.error_desc);
          } else {
            setData(result.data);
          }
        })
        .catch(err => {
          Dialog.error(err.message);
        });
  }

  // console.log(data);

  useEffect(() => {
    if (props.active && (!loaded || props.action === 'POP')) {
      load();
    }
  }, [props.active]);

  const [receiving, setReceiving] = useState(false);

  const handle = task => {
    // let state = data[task.id];
    if (!task.isReceivedReward) {
      if (task.isCompleted) {
        if (receiving) {
          return;
        }
        setReceiving(true);
        Dialog.loading();
        general.axios.post('/user/task/takeBalance', {name: task.name})
          .finally(() => {
            setReceiving(false);
            Dialog.close();
          })
          .then(res => {
            let result = res.data;
            if (!result.status.succeed) {
              Dialog.error(result.status.error_desc);
            } else {
              Dialog.success('领取成功');
              // data[task.id].isCompleted = true;
              // data[task.id].isReceivedReward = true;
              // setData({...data});
              load();
            }
          })
          .catch(err => {
            Dialog.error(err.message);
          });
      } else {
        if(task.eventType == 'msg') {
          Dialog.alert('温馨提示', task.alertMsg);
        } else {
          Dialog.alert('温馨提示', task.remark);
        }
      }
    }
  }

  return <div>
    <div className="task-welfare" >
      <img src="/resources/task/welfare-body-bg1.png" />
      <div className="welfare-body" style={{backgroundImage: 'url(/resources/task/welfare-body-bg2.png)'}}>
        <div className="container">
          <div className="tasks">
            {data.map(item => <div className="task" onClick={() => handle(item)}>
              <div className="icon"><img src={item.icon}/></div>
              <div className="info">
                <div className="name">
                  {item.title}
                  <br/>
                  {
                    item.name != 'Recharge1000' && item.name != 'Recharge100' ?
                    <>
                    {item.total > 0 ? <div className="frequency">({item.completedTotal}/{item.total})</div> : null}
                    <div className="reward">{item.rewardDesc}</div>
                    </>
                    : null
                  }
                  {/* <div className="reward">{item.rewardDesc}</div> */}
                </div>
                {
                  item.name == 'Recharge1000' || item.name == 'Recharge100' ?
                  <div className="weird">
                  {item.total > 0 ? <div className="frequency">({item.completedTotal}/{item.total})</div> : null}
                  <div className="reward">{item.rewardDesc}</div>
                  </div>
                  : null
                }
                <div className="desc">{item.remark}</div>
              </div>
              <div className={'operate ' + (item.isCompleted ? (item.isReceivedReward ? 'completed' : 'complete') : '')}>
                <img src={'/resources/task/' + (item.isCompleted ? (item.isReceivedReward ? 'been-completed' : 'go-receive') : item.btnTitle) + '.png' } />
              </div>
            </div>)}
            {/* {tasks.map(task => data[task.id]? <div className="task" onClick={() => handle(task)}>
              <div className="icon"><img src={'/resources/task/welfare-' + (task.id) + '.png'} alt=""/></div>
              <div className="info">
                <div className="name">
                  {task.name}
                  <div className="reward">+{data[task.id]?.balance}金币</div>
                </div>
                <div className="desc">{task.info}</div>
              </div>
              <div className={'operate' + (data[task.id]?.completed ? (data[task.id]?.taked ? ' completed' : ' complete') : '')}>
                <img src={'/resources/task/'+ (data[task.id]?.completed ? (data[task.id]?.taked ? 'been- completed' : 'go-receive') : (task.operalias)) +'.png'} />
              </div>
            </div>:null)} */}
          </div>
        </div>
      </div>
    </div>
  </div>;
};